import { Routes } from '@angular/router';

export const routes: Routes = [
    // account tiene layout propio — debe ir ANTES del PublicLayout para que
    // path:'' (prefix) no lo intercepte con el wildcard **
    {
        path: 'account',
        loadChildren: () => import('@features/account/account.routes').then(m => m.accountRoutes),
    },
    // PublicLayout envuelve el resto de rutas públicas (incluye navbar)
    {
        path: '',
        loadComponent: () => import('./layouts/public-layout/public-layout').then(m => m.PublicLayout),
        children: [
            // Home TEMPORAL (informativa huésped + hotelero) mientras hay pocos alojamientos.
            // Para volver al marketplace: descomentar la home original y quitar esta.
            {
                path: '',
                loadComponent: () => import('@features/public/pages/landing-page/landing-page').then(m => m.LandingPage),
            },
            // Home ORIGINAL (buscador + destinos/hoteles destacados) — oculta temporalmente
            // {
            //     path: '',
            //     loadComponent: () => import('@features/public/pages/home-page/home-page').then(m => m.HomePage),
            // },
            {
                path: 'auth',
                loadChildren: () => import('@features/auth/auth.routes').then(m => m.authRoutes),
            },
            // Páginas del marketplace (hoteles y buscador) — ocultas temporalmente
            // hasta tener inventario suficiente. Al estar comentadas caen en el 404.
            // {
            //     path: 'hotels',
            //     loadChildren: () => import('@features/hotels/hotel.routes').then(m => m.hotelRoutes),
            // },
            // {
            //     path: 'search',
            //     loadComponent: () => import('@features/search/pages/search-page/search-page').then(m => m.SearchPage),
            // },
            {
                path: 'contact',
                loadComponent: () => import('@features/public/pages/contact-page/contact-page').then(m => m.ContactPage),
            },
            {
                path: 'privacy',
                loadComponent: () => import('@features/public/pages/privacy-page/privacy-page').then(m => m.PrivacyPage),
            },
            {
                path: 'terms',
                loadComponent: () => import('@features/public/pages/terms-page/terms-page').then(m => m.TermsPage),
            },
            {
                path: '**',
                loadComponent: () => import('@features/public/pages/not-found-page/not-found-page').then(m => m.NotFoundPage),
            },
        ],
    },
];
